export let ExperimentKeys;
(function (ExperimentKeys) {
  ExperimentKeys["ACQ0170"] = "acq-0170";
  ExperimentKeys["ACQ0172"] = "acqly-acq-0172";
  ExperimentKeys["ACQ0173"] = "acq-0173";
})(ExperimentKeys || (ExperimentKeys = {}));
export const getExperimentKeys = () => {
  return Object.values(ExperimentKeys);
};
export const TEST_KEY = 'TEST-002';